import { render, staticRenderFns } from "./FAQView.vue?vue&type=template&id=115e5ca4&scoped=true"
import script from "./FAQView.vue?vue&type=script&lang=js"
export * from "./FAQView.vue?vue&type=script&lang=js"
import style0 from "./FAQView.vue?vue&type=style&index=0&id=115e5ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115e5ca4",
  null
  
)

export default component.exports